import React from 'react';
import IconAvailable from '../../../../../assets/svg/icon-available.svg';
import MessageItem from '../messages/Message';
import { styles } from './AvailabilityStatus.css';

export type AvailabilityStatusProps = {
  preOrder?: boolean;
  isDigital?: boolean;
  digitalDeliveryMsg?: string;
  digitalDeliveryPreOrderMsg?: string;
};

const AvailabilityStatus = ({
  preOrder,
  isDigital,
  digitalDeliveryMsg,
  digitalDeliveryPreOrderMsg,
}: AvailabilityStatusProps): JSX.Element => {
  return (
    <div className={styles.container({ isDigital })}>
      {isDigital ? (
        <MessageItem
          inline
          leftComponent={<IconAvailable />}
          message={{
            MessageType: 'Neutral',
            Message: preOrder ? digitalDeliveryPreOrderMsg : digitalDeliveryMsg,
          }}
          className="alert-digital"
        />
      ) : null}
    </div>
  );
};

export default AvailabilityStatus;
